import api from "./api";
import { ActionContext } from "vuex";
import log from "loglevel";
import { RegistrationApiRequest } from "@/containers/paymentInformationRegisterStripe/Requests/RegistrationApiRequest";
import {
  PostOffersWacomContractRequest,
  PostSaleContractRequest
} from "@/containers/paymentInformationRegisterStripe/Requests";

interface State {}

type MyActionContext = ActionContext<State, State>;

export default {
  namespaced: true,
  state: {} as State,
  getters: {},
  actions: {
    async registrationApi(
      context: MyActionContext,
      params: RegistrationApiRequest
    ) {
      const registrationType = params.registrationType;
      const request = params.request;

      try {
        if (registrationType === "postApplicationContract") {
          const res = await api.postApplicationContract(request);
          return res.data;
        }
        if (registrationType === "postOffersContinuedPatronageContract") {
          const res = await api.postOffersContinuedPatronageContract(request);
          return res.data;
        }
        if (registrationType === "postOffersWacomContract") {
          const res = await api.postOffersWacomContract(
            request as PostOffersWacomContractRequest
          );
          return res.data;
        }
        if (registrationType === "postOffersDebutContract") {
          const res = await api.postOffersDebutContract(request);
          return res.data;
        }
        if (registrationType === "postIceApplicationPayContract") {
          const res = await api.postIceApplicationPayContract(request);
          return res.data;
        }
        if (registrationType === "postOffersActivationCodeWacomContract") {
          const res = await api.postOffersActivationCodeWacomContract(request);
          return res.data;
        }
        if (
          registrationType ===
          "postOffersActivationCodeWacomContractStripeBilling"
        ) {
          const res = await api.postOffersActivationCodeWacomContractStripeBilling(
            request
          );
          return res.data;
        }
        if (registrationType === "postPaymentInformationEdit") {
          const res = await api.postPaymentInformationEdit(request);
          return res.data;
        }
        if (registrationType === "putPaymentInformationEdit") {
          const res = await api.putPaymentInformationEdit(request);
          return res.data;
        }
        if (registrationType === "postSaleContract") {
          const res = await api.postSaleContract(
            request as PostSaleContractRequest
          );
          return res.data;
        }
        throw new Error(
          "registrationApi: Unexpected registrationType: " + registrationType
        );
      } catch (error) {
        log.error("registrationApi error:", error);
        throw error;
      }
    }
  },
  mutations: {}
};
